const FEATURE_BASE_API_ROUTE = '/feature';

export const FEATURE_API_ROUTE = {
  index: () => FEATURE_BASE_API_ROUTE,
  config: () => `${FEATURE_BASE_API_ROUTE}/config`,
} as const;
